<template>
  <div class="layout">
    <div class="header-bar">
      <el-button type="primary" @click="search()" size="mini">查询</el-button>
      <el-button type="primary" @click="exportExcel()" size="mini">导出</el-button>
    </div>
    <div class="header">
      <el-descriptions size="mini" :column="2" direction="horizontal" border :labelStyle="{width: '100px'}" :contentStyle="{width:'41%'}">
        <!--        <el-descriptions-item label="部门">-->
        <!--          {{mainObj.department_name}}-->
        <!--        </el-descriptions-item>-->
<!--        <el-descriptions-item label="项目">-->
<!--          {{mainObj.project_name}}-->
<!--        </el-descriptions-item>-->
<!--        <el-descriptions-item label="客户名称">-->
<!--          <el-input v-model="mainObj.customer_name" placeholder="请输入客户名称" size="mini"></el-input>-->
<!--        </el-descriptions-item>-->
        <el-descriptions-item label="房产名称">
          <el-autocomplete size="mini"
                           style="min-width: 400px;max-width: 100%"
                           v-model="mainObj.house_name"
                           :fetch-suggestions="querySearchAsyncRoom"
                           placeholder="请输入房产"
                           popper-class="autocomplete-room"
          ></el-autocomplete>
        </el-descriptions-item>
        <el-descriptions-item label="操作时间">
          <el-date-picker v-model="where.create_time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="mini" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-descriptions-item>
<!--        <el-descriptions-item label="操作类型">-->
<!--          <el-select v-model="where.operation_type" placeholder="请选择操作类型" size="mini">-->
<!--            <el-option label="新增" value="add"></el-option>-->
<!--            <el-option label="修改" value="update"></el-option>-->
<!--            <el-option label="删除" value="delete"></el-option>-->
<!--          </el-select>-->
<!--        </el-descriptions-item>-->
<!--        <el-descriptions-item label="操作人">-->
<!--          <el-input v-model="mainObj.user_name" placeholder="请输入操作人" size="mini"></el-input>-->
<!--        </el-descriptions-item>-->
      </el-descriptions>
    </div>
    <div class="content">
      <el-table :data="pageData.data" style="width: 100%" height="calc( 100vh - 400px )" border v-loading="loading">
        <el-table-column label="房产" prop="房产" width="320" fixed></el-table-column>
        <el-table-column label="绑定业主" prop="绑定业主"></el-table-column>
        <el-table-column label="绑定业主数量" prop="绑定业主数量" width="100"></el-table-column>
      </el-table>
    </div>
    <div class="footer">
      <el-pagination
        layout="prev, pager, next"
        :current-page="pageData.current_page"
        :page-size="pageData.per_page"
        :total="pageData.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "HouseCustomerWarning",
  inject: ['mainObj'],
  data() {
    return {
      where:{
        create_time:[],
        operation_type:'',
      },
      loading:false,
      pageData: {
        data:[],
        total:0,
        current_page:1,
        per_page:10,
      },
    }
  },
  created() {
    this.getList()
  },
  methods:{
    getList(){
      const that = this
      that.loading=true
      ERP.postRequest({
        url: '/admin/CustomerHouse/getHouseCustomer',
        data: {
          ...that.mainObj,
          ...that.where,
          page: this.pageData.current_page,
          limit: this.pageData.per_page,
        }
      },res=>{
        that.loading=false
        if(res.code === 1){
          console.log(res.data.data)
          that.pageData = res.data
        }
      })
    },
    search(){
      this.pageData.current_page=1;
      this.getList()
    },
    handleCurrentChange(currentPage){
      const that=this;
      that.pageData.current_page=currentPage;
      that.getList()
    },
    querySearchAsyncRoom(queryString, cb){
      if(!queryString){
        cb([]);
      }else {
        ERP.postRequest({
          url:"admin/Customer/getHouseList",
          data:{keyWord:queryString}
        },ret=>{
          if(ret.code) {
            cb(ret.data)
          }
        })
      }

    },
    exportExcel(){
      const that = this
      that.loading=true
      ERP.postRequest({
        url: '/admin/CustomerHouse/getHouseCustomer',
        data: {
          ...that.mainObj,
          ...that.where,
          is_export:1,
        }
      },res=>{
        that.loading=false
        if(res.code === 1){
          console.log(res.data)
          window.open(res.data)
        }
      })
    },
  },
  computed: {

  }
}
</script>

<style lang="scss" scoped>
.layout{
  display: flex;
  flex-direction: column;
  height: 100%;

  .header{
    display: flex;
  }

  .content{
    //flex: 1;
    //display: flex;
    //flex-direction: column;
    //align-items: center;
    //justify-content: center;
  }

  .footer{
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/components/customer-log/components/HouseCustomerWarning.vue